(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/result-distribution.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/result-distribution.js');
"use strict";

const {
  useMemo
} = React;
const {
  WinDivWrapper
} = svs.components.tipsen.winDiv;
const {
  useGetDrawState
} = svs.components.tipsen.hooksWager;
const {
  useDrawResults
} = svs.components.tipsen.hooks;
const {
  drawStateEnums
} = svs.components.sport.tipsenShared;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  getDefinitionByProduct
} = svs.components.tipsen.engine.utils;
const {
  RemainingRows
} = svs.components.tipsen.remainingRows;
const ResultDistribution = _ref => {
  var _getDefinitionByProdu;
  let {
    drawNumber,
    productId
  } = _ref;
  const className = 'pg_windiv--result';
  const drawState = useGetDrawState(productId, drawNumber);
  const isDrawCompleted = drawState === drawStateEnums.FINALIZED;
  const {
    data
  } = useDrawResults({
    productId,
    drawNumber
  });
  const [drawResults, winDivisions, multiForecast] = data;
  const eventTypeId = ((_getDefinitionByProdu = getDefinitionByProduct(productId)) === null || _getDefinitionByProdu === void 0 ? void 0 : _getDefinitionByProdu.outcomes.eventTypeId) || undefined;
  const isGoalCount = useMemo(() => eventTypeId === EventTypeId.GOAL_COUNT, [eventTypeId]);
  const isRemainingRowsEnabled = svs.core.detect.feature('ft-tipsen-remaining-rows');
  const shouldDisplayRemainingRows = isGoalCount && !isDrawCompleted && isRemainingRowsEnabled;
  return React.createElement(React.Fragment, null, React.createElement(WinDivWrapper, {
    className: className,
    drawNumber: drawNumber,
    drawResults: drawResults,
    drawWinDivs: winDivisions,
    isDrawCompleted: isDrawCompleted,
    multiForecast: multiForecast,
    productId: productId
  }), shouldDisplayRemainingRows && React.createElement(RemainingRows, {
    className: "pg_remaining_rows--result",
    drawNumber: drawNumber,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.routeResult.ResultDistribution', ResultDistribution);

 })(window);